"use strict";

jQuery(document).ready(function ($) {
  var docWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', docWidth > 0 ? docWidth + (docWidth / 2 + 1) + "px" : "18px");

  // Hamburger menu
  $('.hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('.main-menu').slideToggle('slow');
  });

  // Hero block carousel
  $('.hero__image-carousel').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    speed: 400,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true
  });

  // fix autoplay after dot clicked
  $('.slick-dots li button').focus(function () {
    this.blur();
  });

  // Select all links with hashes
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]').not('[href="#0"]').click(function (event) {
    // On-page links
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function () {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          }
        });
      }
    }
  });

  var scrollableElements = document.getElementsByClassName("side-scroll");
  var _loop = function _loop(i) {
    var pos = {
      top: 0,
      left: 0.1,
      x: 0,
      y: 0
    };
    var mouseDownHandler = function mouseDownHandler(e) {
      // scrollableElements[i].style.cursor = 'grabbing';
      scrollableElements[i].style.userSelect = 'none';
      pos = {
        left: scrollableElements[i].scrollLeft,
        top: scrollableElements[i].scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY
      };
      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    };
    var mouseMoveHandler = function mouseMoveHandler(e) {
      // How far the mouse has been moved
      var dx = e.clientX - pos.x;
      var dy = e.clientY - pos.y;

      // Scroll the element
      scrollableElements[i].scrollTop = pos.top - dy;
      scrollableElements[i].scrollLeft = pos.left - dx;
    };
    var mouseUpHandler = function mouseUpHandler() {
      // scrollableElements[i].style.cursor = 'grab';
      scrollableElements[i].style.removeProperty('user-select');
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    // Attach the handler
    scrollableElements[i].addEventListener('mousedown', mouseDownHandler);
  };
  for (var i = 0; i < scrollableElements.length; i++) {
    _loop(i);
  }

  // Mobile hamburger menu
  $('.header__hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('.header__nav--mobile').toggleClass('is-active');
    $('body').toggleClass('body-overflow');
  });
  $('.user-timezone').val(Intl.DateTimeFormat().resolvedOptions().timeZone);

  // Add a click event listener to all elements with the class 'scroll-link'
  $('.scroll-to-link').on('click', function (e) {
    e.preventDefault(); // Prevent default behavior of the link
    var target = $(this).attr('href'); // Get the target anchor from the href attribute
    var targetElement = $(target)[0]; // Convert the target to a DOM element

    // Scroll to the target element using scrollIntoView
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        // Use smooth scrolling
        block: 'start' // Align the top of the target element with the top of the viewport
      });
    }
  });

  $('.header__nav--mobile').on('click', '.menu > .menu-item-has-children > a', function (e) {
    e.preventDefault();
    var menuItem = $(this).closest('li');
    var extraButtons = $('.extra-button');
    if (menuItem.hasClass('active')) {
      menuItem.removeClass('active');
      menuItem.siblings().removeClass('inactive');
      extraButtons.removeClass('inactive');
    } else {
      menuItem.addClass('active');
      menuItem.siblings().addClass('inactive');
      extraButtons.addClass('inactive');
    }
  }).on('click', '.header__nav--search a', function (e) {
    e.preventDefault();
    var headerNavMobile = $('.header__nav--mobile');
    var searchOverlay = $('.search-overlay');
    var searchHamburger = $('.search-overlay__hamburger--elements');
    headerNavMobile.addClass('has-overlay');
    searchOverlay.addClass('active');
    searchHamburger.addClass('active');
  }).on('click', '.search-overlay__hamburger', function () {
    var headerNavMobile = $('.header__nav--mobile');
    var searchOverlay = $('.search-overlay');
    var searchHamburger = $('.search-overlay__hamburger--elements');
    searchHamburger.removeClass('active');
    searchOverlay.removeClass('active');
    headerNavMobile.removeClass('has-overlay');
  });

  /**
   * animation
   */

  if (typeof gsap !== 'undefined') {
    var animateFrom = function animateFrom(elem, direction) {
      direction = direction || 1;
      var x = 0,
        y = direction * 100;
      if (elem.classList.contains("gs__slideIn--from-left")) {
        x = -100;
        y = 0;
      } else if (elem.classList.contains("gs__slideIn--from-right")) {
        x = 100;
        y = 0;
      }
      elem.style.transform = "translate(" + x + "px, " + y + "px)";
      elem.style.opacity = "0";
      gsap.fromTo(elem, {
        x: x,
        y: y,
        autoAlpha: 0
      }, {
        duration: 1.25,
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: "expo",
        overwrite: "auto",
        stagger: 0.2
      });
    };
    var hide = function hide(elem) {
      gsap.set(elem, {
        autoAlpha: 0
      });
    };
    gsap.registerPlugin(ScrollTrigger);
    gsap.utils.toArray(".gs__slideIn").forEach(function (elem) {
      hide(elem); // assure that the element is hidden when scrolled into view

      ScrollTrigger.create({
        trigger: elem,
        start: "top 70%",
        end: "bottom 25%",
        //	markers: {startColor: "#b825e2", endColor: "#f31010", fontSize: "12px"},
        onEnter: function onEnter() {
          animateFrom(elem);
        },
        once: true
      });
    });
  }
});